module.exports = __webpack_public_path__ + "static/media/slider2.2aef05a8.jpg";